import React from 'react';
import styled from 'styled-components';
import { Player } from '../../services/Restorative/types';

import RemoveSVG from './remove.svg';

// Define the props for the component
type SelectedPlayerListProps = {
  players: Player[];
  removeSelectedPlayer: (id: number, name: string) => void;
};

// Styled components
const PlayerContainer = styled.div``;

const PlayerItem = styled.div(({ theme }) => {
  const { color } = theme.new;
  return `
    position: relative;
    margin-right: 10px;
    display: inline-block;
    background-color: ${color.neutral[0]};
    border-radius: 1000px;
    border: 1px solid ${color.neutral[5]};
    padding: 8px 14px;
    cursor: pointer;
    &:hover {
      background-color: ${color.neutral[1]};
    }
    margin-bottom: 10px;
  `;
});

const NameText = styled.span(({ theme }) => {
  return `
    margin-right: 8px;
    color: ${theme.new.color.neutral[9]};
  `;
});

const RemoveButton = styled.span(({ theme }) => {
  return `
  
    position: relative;
    font-size: ${theme.new.type.size[16]};
    cursor: pointer;
  `;
});

const RemoveButtonIcon = styled.img`
  display: inline-block;
  width: 10px;
`;

const SelectedPlayerList: React.FC<SelectedPlayerListProps> = ({ players, removeSelectedPlayer }) => {
  const handleRemovePlayer = (id: number, name: string) => {
    removeSelectedPlayer(id, name);
  };

  return (
    <PlayerContainer>
      {players.map((player) => (
        <PlayerItem key={player.id} onClick={() => handleRemovePlayer(player.id, player.name)}>
          <NameText>{player.name}</NameText>
          <RemoveButton>
            <RemoveButtonIcon src={RemoveSVG} />
          </RemoveButton>
        </PlayerItem>
      ))}
    </PlayerContainer>
  );
};

export default SelectedPlayerList;
